var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAmazonIllustration = function SvgAmazonIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 65 63"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#amazonIllustration_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.737,
    cy: 30.628,
    fill: "#fff",
    rx: 28.913,
    ry: 27.628
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#amazonIllustration_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M45.936 42.873c-15.605 7.427-25.29 1.213-31.489-2.56-.383-.239-1.035.055-.47.705 2.066 2.504 8.834 8.54 17.67 8.54 8.84 0 14.1-4.824 14.758-5.666.653-.834.191-1.294-.469-1.019m4.383-2.42c-.42-.546-2.548-.647-3.888-.483-1.342.16-3.357.98-3.181 1.473.09.184.273.101 1.195.019.924-.093 3.514-.42 4.053.286.543.71-.825 4.094-1.075 4.64-.242.545.092.686.545.322.448-.363 1.257-1.304 1.8-2.635.54-1.339.87-3.207.55-3.622"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M35.443 27.72c0 1.948.05 3.573-.935 5.304-.795 1.407-2.055 2.272-3.462 2.272-1.92 0-3.039-1.463-3.039-3.623 0-4.263 3.82-5.037 7.436-5.037zm5.044 12.19c-.33.296-.809.317-1.182.12-1.66-1.378-1.955-2.019-2.87-3.334-2.743 2.8-4.685 3.637-8.245 3.637-4.207 0-7.485-2.596-7.485-7.795 0-4.059 2.202-6.824 5.333-8.174 2.715-1.196 6.507-1.407 9.405-1.738v-.647c0-1.19.092-2.596-.605-3.623-.612-.922-1.78-1.302-2.807-1.302-1.906 0-3.609.978-4.024 3.004-.084.45-.415.894-.865.915l-4.854-.52c-.408-.092-.858-.423-.746-1.049 1.119-5.881 6.43-7.654 11.186-7.654 2.434 0 5.613.647 7.534 2.49 2.434 2.273 2.202 5.305 2.202 8.604v7.795c0 2.342.97 3.37 1.885 4.636.324.45.394.992-.014 1.33a211 211 0 0 0-3.834 3.32z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M45.936 42.873c-15.605 7.427-25.29 1.213-31.489-2.56-.383-.239-1.035.055-.47.705 2.066 2.504 8.834 8.54 17.67 8.54 8.84 0 14.1-4.824 14.758-5.666.653-.834.191-1.294-.469-1.019m4.383-2.42c-.42-.546-2.548-.647-3.888-.483-1.342.16-3.357.98-3.181 1.473.09.184.273.101 1.195.019.924-.093 3.514-.42 4.053.286.543.71-.825 4.094-1.075 4.64-.242.545.092.686.545.322.448-.363 1.257-1.304 1.8-2.635.54-1.339.87-3.207.55-3.622"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M35.443 27.72c0 1.948.05 3.573-.935 5.304-.795 1.407-2.055 2.272-3.462 2.272-1.92 0-3.039-1.463-3.039-3.623 0-4.263 3.82-5.037 7.436-5.037zm5.044 12.19c-.33.296-.809.317-1.182.12-1.66-1.378-1.955-2.019-2.87-3.334-2.743 2.8-4.685 3.637-8.245 3.637-4.207 0-7.485-2.596-7.485-7.795 0-4.059 2.202-6.824 5.333-8.174 2.715-1.196 6.507-1.407 9.405-1.738v-.647c0-1.19.092-2.596-.605-3.623-.612-.922-1.78-1.302-2.807-1.302-1.906 0-3.609.978-4.024 3.004-.084.45-.415.894-.865.915l-4.854-.52c-.408-.092-.858-.423-.746-1.049 1.119-5.881 6.43-7.654 11.186-7.654 2.434 0 5.613.647 7.534 2.49 2.434 2.273 2.202 5.305 2.202 8.604v7.795c0 2.342.97 3.37 1.885 4.636.324.45.394.992-.014 1.33a211 211 0 0 0-3.834 3.32z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "amazonIllustration_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.75 11.75H51.3V50.3H12.75z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "amazonIllustration_svg__a",
    width: 64.249,
    height: 61.68,
    x: 0.254,
    y: 0.43,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.642,
    dy: 0.642
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.606
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_420_1172"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_420_1172",
    result: "shape"
  })))));
};
export default SvgAmazonIllustration;